import type {
  CreateCompensationVariantPaymentRequest,
  CreateCompensationVariantPaymentRequestAPI,
  CreateCompensationVariantPaymentResponse,
  CreateCompensationVariantPaymentResponseAPI,
  GetCompensationConfigResponse,
  GetCompensationConfigResponseAPI,
  GetCompensationVariantPaymentResponse,
  GetCompensationVariantPaymentResponseAPI,
  GetCompensationVariantPaymentsResponse,
  GetCompensationVariantPaymentsResponseAPI,
  InitCompensationVariantPaymentsRequest,
  InitCompensationVariantPaymentsRequestAPI,
  UpdateCompensationVariantPaymentRequest,
  UpdateCompensationVariantPaymentRequestAPI,
} from '@omnipresentgroup/types';

export const transformCompensationConfigFromAPI = ({
  variant_payments_types,
  source,
  description,
}: GetCompensationConfigResponseAPI): GetCompensationConfigResponse => ({
  variantPaymentsTypes: variant_payments_types.map((item) => ({
    recurrence: item.recurrence,
    mandatory: item.mandatory,
    type: item.type,
    subtype: item.subtype,
    name: item.name,
    rangeMin: item.range_min,
    rangeMax: item.range_max,
  })),
  source,
  description,
});

export const transformCompensationVariantPaymentRequestFromAPI = ({
  company_id,
  employee_id,
  employee_name,
  user_id,
  effective_date,
  end_date,
  requested_at,
  requested_by_auth_id,
  additional_notes,
  is_mandatory,
  is_internal,
  ...rest
}: GetCompensationVariantPaymentResponseAPI): GetCompensationVariantPaymentResponse => ({
  companyId: company_id,
  employeeId: employee_id,
  employeeName: employee_name,
  userId: user_id,
  effectiveDate: effective_date,
  endDate: end_date,
  requestedAt: requested_at,
  requestedByAuthId: requested_by_auth_id,
  additionalNotes: additional_notes,
  isMandatory: is_mandatory,
  isInternal: is_internal,
  ...rest,
});

export const transformCompensationVariantPaymentsRequestFromAPI = (
  items: GetCompensationVariantPaymentsResponseAPI,
): GetCompensationVariantPaymentsResponse =>
  items.map((item) => transformCompensationVariantPaymentRequestFromAPI(item));

export const transformUpdateCompensationVariantPaymentRequestToAPI = ({
  amount,
  reason,
  additionalNotes,
}: UpdateCompensationVariantPaymentRequest): UpdateCompensationVariantPaymentRequestAPI => ({
  amount,
  reason,
  additional_notes: additionalNotes,
});

export const transformCreateCompensationVariantPaymentRequestToAPI = ({
  type,
  subtype,
  recurrence,
  amount,
  reason,
  additionalNotes,
  employeeId,
  source,
  effectiveDate,
  endDate,
  dryRun,
}: CreateCompensationVariantPaymentRequest): CreateCompensationVariantPaymentRequestAPI => ({
  type,
  subtype,
  recurrence,
  amount,
  reason,
  additional_notes: additionalNotes,
  employee_id: employeeId,
  source,
  effective_date: effectiveDate,
  end_date: endDate,
  dry_run: dryRun,
});

export const transformCreateCompensationVariantPaymentResponseFromAPI = ({
  company_id,
  employee_id,
  employee_name,
  user_id,
  effective_date,
  end_date,
  requested_at,
  requested_by_auth_id,
  additional_notes,
  is_mandatory,
  is_internal,
  prefunding,
  ...rest
}: CreateCompensationVariantPaymentResponseAPI): CreateCompensationVariantPaymentResponse => ({
  companyId: company_id,
  employeeId: employee_id,
  employeeName: employee_name,
  userId: user_id,
  effectiveDate: effective_date,
  endDate: end_date,
  requestedAt: requested_at,
  requestedByAuthId: requested_by_auth_id,
  additionalNotes: additional_notes,
  isMandatory: is_mandatory,
  isInternal: is_internal,
  prefunding: {
    required: prefunding?.required,
    variantPaymentCutoffDate: prefunding?.variant_payment_cutoff_date,
    paymentDueDate: prefunding?.payment_due_date,
  },
  ...rest,
});

export const transformInitCompensationVariantPaymentsRequestToAPI = ({
  employeeId,
  isOverride,
}: InitCompensationVariantPaymentsRequest): InitCompensationVariantPaymentsRequestAPI => ({
  employee_id: employeeId,
  is_override: isOverride,
});
